import { Placemark } from '@pbe/react-yandex-maps'
import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { FC } from 'react'
import { useAppSelector } from 'store/hooks'

import { MarkType } from '../types'
import { MarkIconTypeHref } from '../types/MarkIconType'

import { PlacemarkWrapper } from './PlacemarkWrapper'

interface MarkObjectProps {
  markType: MarkType.clickMark | MarkType.geolocationMark | MarkType.staticMark
}

export const MarkObject: FC<MarkObjectProps> = ({ markType }) => {
  const mark = useAppSelector(yandexMap)[markType]

  return (
    <PlacemarkWrapper geometry={mark.coords}>
      <Placemark
        geometry={mark.coords as [number, number]}
        options={{
          iconLayout: 'default#image',
          iconImageHref: MarkIconTypeHref[mark.icon],
          iconImageSize: [46, 63],
          cursor: 'grab',
        }}
      />
    </PlacemarkWrapper>
  )
}
